module.exports = __webpack_public_path__ + "img/import-2-en.447192ab.png";